module.exports = __webpack_public_path__ + "static/media/logo_small.7dd06532.jpg";